import { render, staticRenderFns } from "./videohome.vue?vue&type=template&id=3a7d72a5&"
import script from "./videohome.vue?vue&type=script&lang=js&"
export * from "./videohome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports